"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _marketing = require("@/api/marketing");
var _article = require("@/api/article");
var _devise = require("@/api/devise");
var _list = _interopRequireDefault(require("./list.json"));
var _linkData = _interopRequireDefault(require("./linkData.json"));
var _marketing2 = _interopRequireDefault(require("./marketing.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'LinkAddress',
  // 组件名称，采用 PascalCase
  data: function data() {
    return {
      constants: this.$constants,
      // 全局常量对象，通常包含分页等全局配置
      dialogVisible: false,
      // 控制弹窗显示/隐藏
      defaultProps: {
        children: 'children',
        // el-tree 组件的子节点字段名
        label: 'title' // el-tree 组件的显示文本字段名
      },
      basicsList: [],
      // 基础链接列表，存放 type=1 的链接数据
      userList: [],
      // 个人中心链接列表，存放 type=3 的链接数据
      distributionList: [],
      // 分销链接列表，存放 type=2 的链接数据
      coupon: [],
      // 优惠券/营销链接列表，存放 type 其它的链接数据
      luckDraw: [],
      // 抽奖链接列表，存放 type=5 的链接数据
      integral: [],
      // 积分链接列表，存放 type=4 的链接数据
      merchantOffline: [],
      // 线下商家链接列表，存放 type=100 的链接数据
      taokeList: [],
      // 淘客链接列表，存放 type=101 的链接数据
      loadingList: false,
      // 控制表格 loading 动画，接口请求时为 true
      currenType: 'link',
      // 当前选中的类型（如 link、product、marketing_link 等）
      currenId: '',
      // 当前选中项的唯一标识 id
      currenUrl: '',
      // 当前选中项的 url
      currenName: '',
      // 当前选中项的名称
      formValidate: {
        page: 1,
        // 商品搜索分页页码
        limit: 10,
        // 商品搜索每页数量
        keywords: '',
        // 商品搜索关键字
        type: 1 // 商品类型，默认 1
      },
      customDate: {
        url: '' // 自定义跳转路径，用户手动输入
      },
      radioData: '',
      // el-table 单选框绑定值，记录当前选中行的索引
      linkId: 0,
      // 选中的链接 id，主要用于商品、活动等类型
      tableList: {},
      // 表格数据对象，包含 list（数据数组）和 total（总数）等
      params: {
        page: 1,
        // 当前分页页码
        limit: 10,
        // 当前分页每页数量
        keywords: '',
        // 搜索关键字
        type: 1,
        // 类型
        name: '' // 名称（部分接口可能用到）
      },
      columns: [
      // 页面链接表格列配置
      {
        title: 'ID',
        key: 'id',
        width: 60
      },
      // ID 列
      {
        title: '页面名称',
        key: 'name',
        width: 150
      },
      // 页面名称列
      {
        title: '页面链接',
        key: 'url'
      } // 页面链接列
      ],
      columns7: [
      // 分类表格列配置
      {
        title: 'ID',
        key: 'id',
        width: 60
      },
      // ID 列
      {
        title: '分类名称',
        key: 'cate_name',
        tree: true
      },
      // 分类名称列，支持树结构
      {
        title: '分类图标',
        slot: 'pic'
      } // 分类图标列，使用插槽
      ],
      columns8: [
      // 商品表格列配置
      {
        title: 'ID',
        key: 'id',
        width: 60
      },
      // ID 列
      {
        title: '商品图片',
        slot: 'image',
        width: 90
      },
      // 商品图片列，使用插槽
      {
        title: '商品名称',
        key: 'store_name'
      } // 商品名称列
      ],
      bargain: [
      // 砍价商品表格列配置
      {
        title: 'ID',
        key: 'id',
        width: 60
      },
      // ID 列
      {
        title: '商品图片',
        slot: 'image',
        width: 90
      },
      // 商品图片列
      {
        title: '商品名称',
        key: 'title'
      } // 商品名称列
      ],
      news: [
      // 文章表格列配置
      {
        title: 'ID',
        key: 'id',
        width: 60
      },
      // ID 列
      {
        title: '文章图片',
        slot: 'image_input',
        width: 90
      },
      // 文章图片列
      {
        title: '文章名称',
        key: 'title'
      } // 文章名称列
      ]
    };
  },
  props: {
    // 父组件传递的参数：fromType 用于区分来源页面，isHotSpot 控制是否热点模式
    fromType: {
      type: String,
      default: '' // 来源类型，决定 categoryData 的内容
    },
    isHotSpot: {
      type: Boolean,
      default: false // 是否热点模式，决定 emit 时是否带上名称
    }
  },
  computed: {
    // 计算属性：根据 fromType 返回不同的分类数据
    // 如果 fromType 为 linkGenerator，则去除第4项（索引3）
    categoryData: function categoryData() {
      var obj = _toConsumableArray(_list.default.data); // 拷贝原始分类数据
      if (this.fromType === 'linkGenerator') {
        obj.splice(3, 1); // 移除第4项
        return obj;
      } else {
        return _toConsumableArray(_list.default.data); // 返回全部分类数据
      }
    },
    // 新增：过滤 userList，避免 v-for 和 v-if 混用
    filteredUserList: function filteredUserList() {
      // 只返回 show 为 true 的 userList 项
      return this.userList.filter(function (item) {
        return item.show !== false;
      });
    }
  },
  methods: {
    // 弹窗打开时初始化数据，重置当前选中项并加载基础链接
    onOpen: function onOpen() {
      this.currenId = ''; // 清空当前选中 id
      this.mockData('link'); // 加载基础链接数据
    },
    // 商品搜索，使用 formValidate 作为参数重新请求商品数据
    handleSearch: function handleSearch() {
      this.params = this.formValidate; // 复制搜索表单参数
      this.mockData('product'); // 加载商品数据
    },
    // 树节点点击事件，切换类型并加载对应数据
    // data: 当前点击的树节点对象，包含 type 字段
    handleNodeClick: function handleNodeClick(data) {
      this.params.page = 1; // 切换类型时重置分页
      this.tableList.list = []; // 清空表格数据
      this.linkId = null; // 清空选中 id
      this.radioData = null; // 清空单选框
      this.$set(this, 'currenType', data.type); // 切换当前类型
      this.mockData(data.type); // 加载对应类型数据
    },
    // 根据类型加载不同的数据，支持本地静态和接口异步
    // type: 类型字符串，如 'link'、'product'、'marketing_link' 等
    mockData: function mockData(type) {
      var _this = this;
      var data = []; // 本地静态数据临时变量
      // 处理本地静态数据类型
      if (type === 'marketing_link') {
        // 营销相关静态数据
        data = _marketing2.default.data.list;
      } else if (type === 'link') {
        // 基础链接静态数据
        data = _linkData.default.data.list;
      } else if (type === 'product_category') {
        // 商品分类，接口异步获取
        this.loadingList = true; // 显示 loading
        (0, _product.productCategoryListApi)({
          type: 1,
          status: -1
        }).then(function (res) {
          _this.tableList.list = res; // 赋值分类数据
          _this.loadingList = false; // 隐藏 loading
        });
      } else if (type === 'product') {
        // 商品列表，接口异步获取
        this.loadingList = true;
        (0, _product.productLstApi)(this.params).then(function (res) {
          _this.tableList = res; // 赋值商品数据
          _this.loadingList = false;
        });
      } else if (type === 'seckill') {
        // 秒杀商品，接口异步获取
        this.loadingList = true;
        (0, _marketing.seckillStoreListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.loadingList = false;
        });
      } else if (type === 'bargain') {
        // 砍价商品，接口异步获取
        this.loadingList = true;
        (0, _marketing.bargainListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.loadingList = false;
        });
      } else if (type === 'combination') {
        // 拼团商品，接口异步获取
        this.loadingList = true;
        (0, _marketing.combinationListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.loadingList = false;
        });
      } else if (type === 'news') {
        // 文章列表，接口异步获取
        this.loadingList = true;
        (0, _article.ListArticle)(this.params).then(function (res) {
          _this.tableList = res;
          _this.loadingList = false;
        });
      } else if (type === 'micro') {
        // 微页面，接口异步获取
        this.loadingList = true;
        (0, _devise.pagediyListApi)(this.params).then(function (res) {
          _this.tableList = res;
          _this.loadingList = false;
        });
      }
      // 以下为本地静态数据分类，按 type 分类到不同数组
      var basicsList = []; // type=1 基础链接
      var distributionList = []; // type=2 分销链接
      var userList = []; // type=3 个人中心链接
      var integral = []; // type=4 积分链接
      var luckDraw = []; // type=5 抽奖链接
      var coupon = []; // 其它类型，营销/优惠券
      var group = []; // type=8 拼团链接
      var merchantOffline = []; // type=100 线下商家
      var taokeList = []; // type=101 淘客链接
      // 遍历本地静态数据，按 type 分类
      data.forEach(function (e) {
        if (e.type === 1) {
          basicsList.push(e);
        } else if (e.type === 2) {
          distributionList.push(e);
        } else if (e.type === 3) {
          userList.push(e);
        } else if (e.type === 4) {
          integral.push(e);
        } else if (e.type === 5) {
          luckDraw.push(e);
        } else if (e.type === 8) {
          group.push(e);
        } else if (e.type === 100) {
          merchantOffline.push(e);
        } else if (e.type === 101) {
          taokeList.push(e);
        } else {
          coupon.push(e);
        }
      });
      // 将分类结果赋值到 data，供页面渲染
      this.basicsList = basicsList;
      this.distributionList = distributionList;
      this.userList = userList;
      this.coupon = coupon;
      this.luckDraw = luckDraw;
      this.integral = integral;
      this.group = group;
      this.merchantOffline = merchantOffline;
      this.taokeList = taokeList;
    },
    // 选中链接，赋值当前项信息
    // item: 被点击的链接对象，包含 id、url、name
    getUrl: function getUrl(item) {
      this.currenId = item.id; // 记录当前选中 id
      this.currenUrl = item.url; // 记录当前选中 url
      this.currenName = item.name; // 记录当前选中名称
    },
    // 表格单选事件，记录选中ID
    // row: 当前选中的表格行对象
    singleElection: function singleElection(row) {
      this.linkId = row.id; // 记录选中 id
    },
    // 确认选择，向父组件传递选中链接
    // 根据 currenType 判断链接类型，拼接不同的跳转路径
    handleSubmit: function handleSubmit() {
      switch (this.currenType) {
        case 'product':
          // 商品详情页
          if (this.isHotSpot) {
            // 热点模式，带上名称
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=0"), '商品详情');
          } else {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=0"));
          }
          break;
        case 'seckill':
          // 秒杀商品详情页
          if (this.isHotSpot) {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=1"), '秒杀商品');
          } else {
            this.$emit('linkUrl', "/pages/goods/goods_details/index?id=".concat(this.linkId, "&mt=1"));
          }
          break;
        case 'bargain':
          // 砍价商品详情页
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/activity/goods_bargain_details/index?id=' + this.linkId + '&mt=2', '砍价商品');
          } else {
            this.$emit('linkUrl', '/pages/activity/goods_bargain_details/index?id=' + this.linkId + '&mt=2');
          }
          break;
        case 'combination':
          // 拼团商品详情页
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/activity/goods_combination_details/index?id=' + this.linkId, '拼团商品');
          } else {
            this.$emit('linkUrl', '/pages/activity/goods_combination_details/index?id=' + this.linkId);
          }
          break;
        case 'news':
          // 文章详情页
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/goods/news_details/index?id=' + this.linkId, '文章详情');
          } else {
            this.$emit('linkUrl', '/pages/goods/news_details/index?id=' + this.linkId);
          }
          break;
        case 'product_category':
          // 商品分类页
          if (this.isHotSpot) {
            this.$emit('linkUrl', '/pages/goods/goods_cate/index', '商品分类');
          } else {
            this.$emit('linkUrl', '/pages/goods/goods_cate/index');
          }
          break;
        case 'custom':
          // 自定义链接
          if (this.isHotSpot) {
            this.$emit('linkUrl', this.customDate.url, '自定义链接');
          } else {
            this.$emit('linkUrl', this.customDate.url);
          }
          break;
        case 'micro':
          // 微页面
          if (this.isHotSpot) {
            this.$emit('linkUrl', "/pages/activity/small_page/index?id=".concat(this.linkId), '微页面');
          } else {
            this.$emit('linkUrl', "/pages/activity/small_page/index?id=".concat(this.linkId));
          }
          break;
        default:
          console.log(this.currenType);
          // 其它类型，直接返回当前选中 url 和名称
          if (this.isHotSpot) {
            this.$emit('linkUrl', this.currenUrl, this.currenName);
          } else {
            this.$emit('linkUrl', this.currenUrl);
          }
          break;
      }
      // 关闭弹窗并重置状态
      this.dialogVisible = false;
      this.currenId = '';
      this.currenType = 'link';
    },
    // 分页-每页数量变化时触发，重新加载数据
    // val: 新的每页数量
    handleSizeChange: function handleSizeChange(val) {
      this.params.limit = val; // 更新每页数量
      this.radioData = null; // 清空单选框
      this.mockData(this.currenType); // 重新加载数据
    },
    // 分页-页码变化时触发，重新加载数据
    // val: 新的页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.params.page = val; // 更新页码
      this.radioData = null; // 清空单选框
      this.mockData(this.currenType); // 重新加载数据
    }
  }
};